import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Form, Field } from 'react-final-form';
import { isHttpError } from 'common/utils/Error';
import {
  DateField,
  InputField,
  Button,
  FormLegend,
} from '@unite-us/app-components';
import { cl2296MedicaidId } from 'common/utils/FeatureFlags/flags';
import { searchContact } from 'actions/Search/Group';
import today from 'common/utils/today';
import minBirthDate from 'common/utils/minBirthDate';
import { Spinner } from 'common/spinners';
import { required } from 'src/common/form/utils/rffValidations';
import Header from './Header';

export class SearchForm extends Component {
  static handleEnter(e) {
    if (e.key === 'Enter') {
      const searchRecordsButton = document.getElementById('search-records-btn');
      if (searchRecordsButton) {
        searchRecordsButton.focus();
      }
    }
  }

  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', SearchForm.handleEnter);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', SearchForm.handleEnter);
  }

  onSubmit(formData) {
    this.setState({ loading: true });
    const { groupId } = this.props;
    const searchAction = this.props.searchContact;
    const showNotification = true;
    return searchAction(groupId, formData, showNotification)
      .then((response) => {
        if (!isHttpError(response)) {
          const contacts = get(response, 'data.data', []);
          return this.props.onComplete(contacts, formData);
        }
        return response;
      }).finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const {
      className,
      header,
      initialValues,
      mainHeader,
      subHeader,
      showMedicaidIdField,
    } = this.props;

    const { loading } = this.state;

    return loading ? (
      <Spinner />
    ) : (
      <div {...(className ? { className } : {})}>
        <Header
          header={header}
          mainHeader={mainHeader}
          subHeader={subHeader}
        />
        <FormLegend />
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          {({ handleSubmit }) => (
            <form className="row" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <Field name="first_name" validate={required}>
                  {(params) => (
                    <InputField
                      {...params}
                      label="First Name"
                      id="first-name"
                      inline={false}
                      required
                    />
                  )}
                </Field>
              </div>
              <div className="col-md-6">
                <Field name="last_name" validate={required}>
                  {(params) => (
                    <InputField
                      {...params}
                      label="Last Name"
                      id="last-name"
                      inline={false}
                      required
                    />
                  )}
                </Field>
              </div>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <Field name="date_of_birth" validate={required}>
                      {(params) => (
                        <DateField
                          {...params}
                          id="date-of-birth"
                          inline={false}
                          label="Date of Birth"
                          maxDate={today()}
                          minDate={minBirthDate()}
                          required
                        />
                      )}
                    </Field>
                  </div>
                </div>
                {
                  showMedicaidIdField ?
                  (
                    <div className="row">
                      <div className="col-md-4">
                        <Field name="medicaid_id">
                          {(params) => (
                            <InputField
                              {...params}
                              label="Medicaid ID"
                              id="medicaid-id"
                              inline={false}
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                  ) : null
                }
              </div>
              <footer className="col-md-12 referral-footer">
                <Button
                  id="search-records-btn"
                  disabled={loading}
                  className="search-records-btn"
                  onClick={handleSubmit}
                  label="Search Our Records"
                  primary
                  style={{ float: 'right' }}
                  type="submit"
                />
              </footer>
            </form>
          )}
        </Form>
      </div>
    );
  }
}

SearchForm.propTypes = {
  className: PropTypes.string,
  groupId: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  initialValues: PropTypes.object,
  mainHeader: PropTypes.string,
  onComplete: PropTypes.func.isRequired,
  searchContact: PropTypes.func.isRequired,
  subHeader: PropTypes.string.isRequired,
  showMedicaidIdField: PropTypes.bool,
};

SearchForm.defaultProps = {
  className: '',
  initialValues: {},
  mainHeader: null,
  showMedicaidIdField: false,
};

function mapStateToProps(state) {
  const { session: { groupId } } = state;
  return {
    groupId,
    showMedicaidIdField: cl2296MedicaidId(state),
  };
}

export default connect(
  mapStateToProps,
  { searchContact },
)(SearchForm);
